module.exports = __webpack_public_path__ + "img/img_cls.2aa7458e.png";